// Japanese dictionary. Keys mirror ko.ts exactly.
// NOTE: lore/marketing copy is a first draft — review for brand voice.
export const ja: Record<string, string> = {
  // ── meta ──
  'meta.title': 'DigMol — Dener叙任 · エルドラシア年代記',

  // ── topbar / wallet ──
  'topbar.become': 'Denerになる',
  'wallet.connect': 'ウォレット接続',
  'wallet.connected': '接続済み',
  'wallet.copy': 'コピー',
  'wallet.copied': 'コピーしました！',
  'wallet.myMol': '私のMOL',
  'wallet.denerDash': '私の代理店ダッシュボード',
  'wallet.admin': '管理者',
  'wallet.disconnect': '接続解除',
  'wallet.roleOwner': 'OWNER',
  'wallet.roleDist': '代理店',
  'wallet.connectCancelled': 'ウォレット接続がキャンセルされました。',
  'wallet.noWalletFallback': 'ウォレットに接続できませんでした。しばらくして再試行してください。',
  'wallet.connectFail': '接続失敗: {msg}',

  // ── モバイルウォレット接続の選択（ディープリンク / WalletConnect） ──
  'wallet.mobileGuide': 'ウォレットを選んで接続します。MetaMask もここから接続できます。',
  'wallet.openInMetaMask': 'MetaMask アプリで開く（補助）',
  'wallet.retryMetaMask': 'MetaMask アプリでもう一度開く',
  'wallet.useMetaMaskApp':
    'MetaMask アプリが既に開いている可能性があります。アプリに切り替えて進めるか、下からもう一度お試しください。',
  'wallet.otherWallet': '他のウォレットに接続',
  'wallet.cancel': '閉じる',
  'wallet.stuckNotice':
    'ウォレットが応答しません。ページを再読み込みするか、MetaMask アプリを再起動してください。',
  'wallet.reload': '再読み込み',
  'wallet.connectWc': 'ウォレットを接続',
  'wallet.preparing': '準備中…',
  'wallet.deadSession': 'ウォレットセッションが期限切れです。ページを再読み込みして再度お試しください。',

  // ── チェーン（ネットワーク）警告 ──
  'chain.wrong': 'ネットワークが BNB Smart Chain ではありません。切り替えが必要です。',
  'chain.switch': 'BSC に切り替え',

  // ── アプリ内ブラウザ（カカオトーク/LINE/Instagram…）外部ブラウザ案内 ──
  'inapp.title': '{app} ではウォレットを接続できません',
  'inapp.desc':
    'セキュリティ上、アプリ内ブラウザではウォレットアプリを開けません。外部ブラウザで開けばすぐ接続できます。',
  'inapp.open': '外部ブラウザで開く',
  'inapp.copy': 'リンクをコピー',
  'inapp.copied': 'リンクをコピーしました。ブラウザに貼り付けてください。',
  'inapp.copyFail': 'コピーに失敗しました。アドレスバーを長押ししてコピーしてください。',
  'inapp.manualOnly': '自動で開けません。リンクをコピーしてブラウザに貼り付けてください。',
  'inapp.justBrowse': 'このまま閲覧する',
  'wallet.deeplinkFailed':
    'MetaMask アプリが開かなかったか、接続されませんでした。下の [ウォレットを接続] からお進みください。',

  // ── language toggle ──
  'lang.toggleAria': '言語切り替え',

  // ── hero / surface ──
  'alt.mole': 'MolePinモグラ',
  'hero.headline': '滅びた王国を<br><em>再び守る者</em>を呼ぶ。',
  'hero.tagline': 'エルドラシアが再び守る者を呼んでいる。',
  'hero.lead':
    '17の黄金モグラ部族の地下王国<b>エルドラシア</b>。16が消えた後、最後の末裔モルフィンが再び穴を掘る。<b>Dener</b>はその傍らで鉱脈を守る守護者リーダー — そしてその叙任は、十分な<b>MOL</b>を抱くことから始まる。',
  'hero.scrollcue': '鉱脈へ降りて叙任を受けよ',

  // ── lore (section 1) ──
  'lore.eyebrow': '第1層 · Denerとは誰か',
  'lore.headline': '売る者ではなく、<br><em>守る者</em>だ。',
  'lore.quote': '「鉱脈を掘る手は多いが、それを守る者は稀だ。」',
  'lore.lead':
    'DenerはMOLエコシステムに貢献しその価値を証明した<b>守護者リーダー</b>だ。モグラのモルフィンが同族の魂で鎖を繋ぐように、Denerは十分なMOLを抱いて鉱脈の安定を支える。この座に上る手続きこそが<b style="color:var(--gold)">PV</b> — Dener叙任だ。',
  'lore.pillar1.title': '守護の資格',
  'lore.pillar1.desc': '2千万MOLを抱く者だけがDenerに叙任される。資格は権利ではなく責任だ。',
  'lore.pillar1.en': '権利ではなく、守護。',
  'lore.pillar2.title': '証明された貢献',
  'lore.pillar2.desc': '叙任はオンチェーンに刻まれる。誰も真似できず、誰もが検証できる。',
  'lore.pillar2.en': 'オンチェーンで証明、誰もが検証。',
  'lore.pillar3.title': '開かれた鉱脈',
  'lore.pillar3.desc': '定められた比率で、入れた分だけ正確に掘る。交渉も差別もない。',
  'lore.pillar3.en': '固定比率。交渉なし。',

  // ── steps (section 2) ──
  'steps.eyebrow': '第2層 · 叙任の道',
  'steps.headline': '四歩で、<br><em>守護者</em>になる。',
  'steps.tagline': 'Denerになる4つのステップ。',
  'steps.s1.t': '穴の入口に立つ — ウォレット接続',
  'steps.s1.d': 'MetaMaskまたは互換ウォレットでBSCに接続する。モバイルはウォレットアプリの内蔵ブラウザで開く。',
  'steps.s2.t': '鉱脈にBNBを入れる',
  'steps.s2.d': '交換するBNBを入力すると、契約に刻まれた比率で掘れるMOLが即座に計算される。',
  'steps.s3.t': 'ツルハシを振るう — 署名',
  'steps.s3.d': '署名一度。コントラクトが比率通りにMOLをウォレットへ送る。',
  'steps.s4.t': '叙任の光が満ちる',
  'steps.s4.d': '抱えたMOLが2千万に届いた瞬間、Denerの資格が開かれる。',

  // ── oath (section 3) ──
  'oath.eyebrow': '第3層 · 鉱脈の誓い',
  'oath.quote':
    '「契約は交渉しない。<br>入れた分だけ、刻まれた比率で — それだけだ。」<span class="src">— THE VEIN, ELDORASIA</span>',
  'oath.lead':
    'この叙任の鉱脈はエコシステムの他のどの契約とも絡んでいない。比率ひとつ、在庫ひとつ、そして君の署名。だから別個に、安全に、検証できる。',

  // ── vein (section 4) ──
  'vein.eyebrow': '最深部 · THE VEIN',
  'vein.headline': '鉱脈に触れた。',
  'vein.tagline': 'BNBがMOLになる場所。守護者が生まれる場所。',
  'panel.title': 'Dener <em>叙任の鉱脈</em>',
  'panel.subtitle': 'PV INVESTITURE · ISOLATED VEIN',
  'panel.gateLabel': 'Dener叙任まで — 抱えた鉱脈',
  'panel.gateLine': '叙任ライン <b>20,000,000 MOL</b>',

  // ── swap box ──
  'swap.bnbLabel': '鉱脈に入れるBNB',
  'swap.molOutLabel': '掘るMOL（契約比率）',
  'swap.rateNote': '比率はコントラクトに刻まれた値で計算されます。',
  'swap.statRate': '契約比率',
  'swap.statStock': '残りの鉱脈',
  'swap.statMol': '私のMOL',
  'swap.contractMeta': 'コントラクトアドレスを設定すると、リアルタイムの比率・在庫が表示されます。',
  'cta.mine': 'ツルハシを振るう — MOLを掘る',

  // ── status / investiture ──
  'status.pending': '○ 未叙任',
  'status.dener': '● Dener叙任',
  'inv.done': '⛏ <b>Denerに叙任されました。</b>鉱脈の守護者資格を備えました。',
  'inv.remaining': '叙任まで<b>{amount} MOL</b>さらに抱える必要があります。',

  // ── become-a-dener modal ──
  'modal.title': 'Dener叙任の<em>儀式</em>',
  'modal.subtitle': 'BECOME A DENER · BNB → MOL',
  'modal.close': '閉じる',
  'modal.gateLabel': 'Dener叙任まで',
  'modal.molRangeLabel': '購入するMOL数量',
  'modal.molRangeOpt': '（最低2千万）',
  'modal.tick1': '2千万',
  'modal.tick2': '1億',
  'modal.tick3': '2億',
  'modal.payLabel': '支払うBNB',
  'modal.priceLoading': '価格を読み込み中…',
  'modal.distLabel': '代理店を選択',
  'modal.distOpt': '（登録済み代理店）',
  'modal.distPlaceholder': '例: alice.dex',
  'modal.outLabel': '受け取るMOL',
  'modal.outNote': '代理店を選択すると割引後の数量が表示されます。',
  'modal.noAddrMeta': '⚠ PV_GATE_ADDRESS 未設定 — .env に VITE_PV_GATE_ADDRESS が必要',
  'modal.priceNoteNoAddr': 'コントラクトアドレス設定後に価格が表示されます。',
  'modal.priceNote': 'MOL {mol} · BNB {bnb}（フィード）',
  'modal.priceFail': '価格を取得できませんでした。',
  'modal.needMolAmount': '購入するMOL数量を設定してください。',
  'modal.noAddrErr': 'PV_GATE_ADDRESS が設定されていません。',
  'modal.discountChip': '<span class="dk">代理店割引 (+{pct}%)</span><span class="dv">+{extra} MOL</span>',
  'modal.rateBase': '基本 {base} MOL + 割引 {extra} MOL',
  'modal.rewardLine': '<br>代理店報酬 {rwd} BNB 自動支給',
  'modal.noDiscountReward': '割引なし · 代理店報酬 {rwd} BNB 自動支給',
  'modal.distHint': '代理店を選択すると割引/報酬が表示されます。',

  // ── 購入者の代表ドメイン案内（逆引き） ──
  'domain.connectFirst': '先にウォレットを接続してください。',
  'domain.checking': 'ウォレット {addr} の代表ドメインを確認中…',
  'domain.checkedWallet': '確認したウォレット: {addr}',
  'domain.noneTitle': 'このウォレットに紐づく代表ドメインがありません。',
  'domain.recheck': '再確認',
  'domain.have': '✓ あなたの代表ドメイン: <b>{name}</b>',
  'domain.guideTitle': 'Dener 申請には dexignation.com の代表ドメインが必要です。',
  'domain.step1': 'dexignation.com でドメインを取得します',
  'domain.step2': '1つのドメインを代表ドメインに指定します',
  'domain.step3': '戻って Dener 申請を進めます',
  'domain.link': 'dexignation.com へ ↗',

  // ── distributor address validation ──
  'dist.valid': '✓ 有効な代理店 — 購入者割引 {disc}% · 代理店報酬 {rwd}%',
  'dist.validName': '✓ {name} → {addr} · 購入者割引 {disc}% · 代理店報酬 {rwd}%',
  'dist.inactive': '無効な代理店です。割引なしで進みます。',
  'dist.notRegistered': '未登録の代理店です。割引なしで進みます。',
  'dist.required': '有効な .dex ドメインを入力しないと叙任を進められません。',
  'dist.requiredBadge': '必須',
  'dist.requiredHint': '割引 .dex ドメインは必須です。',
  'dist.notDexName': '.dex 名を入力してください（例: alice.dex）',
  'dist.resolving': '名前を照会中…',
  'dist.nameNotFound': '未登録の名前です。',
  'dist.noBnbAddr': 'この名前に紐づくBNBアドレスがありません。',
  'dist.resolveError': '名前の照会中にエラーが発生しました。しばらくして再試行してください。',
  'dist.loadingDistributors': '代理店一覧を読み込み中…',
  'dist.selectPlaceholder': '代理店を選択してください',
  'dist.selectRequired': '代理店の選択は必須です。',
  'dist.selectedDistributor': '✓ {name} · Dener割引 {disc}% · 代理店報酬 {rwd}%',
  'dist.selectedInactiveDistributor': '無効な代理店です: {name}。割引なしで進みます。',
  'dist.selectInvalid': '選択した代理店は使用できません。',
  'dist.noDistributors': '登録された代理店がありません。',
  'dist.listError': '代理店一覧を読み込めませんでした。しばらくして再試行してください。',

  // ── distributor dashboard ──
  'dener.title': '私の<em>代理店</em>ダッシュボード',
  'dener.subtitle': 'DISTRIBUTOR DASHBOARD',
  'dener.discLabel': '購入者割引',
  'dener.rwdLabel': '私の報酬',
  'dener.statusLabel': 'ステータス',
  'dener.setLabel': '私の割引率設定',
  'dener.setOpt': '（0〜15%、報酬は自動）',
  'dener.apply': '割引率を適用（署名）',
  'dener.lockedText': '🔒 管理者が割引率/報酬率を設定しました。変更するには管理者にお問い合わせください。',
  'dener.buyersHead': '私を代理店に指定した購入者',
  'dener.active': '有効',
  'dener.inactive': '無効',
  'dener.autoHint': '→ 私の報酬 {n}%',
  'dener.signConfirm': '署名を確認してください…',
  'dener.applied': '✓ 割引率 {pct}% 適用済み',
  'dener.buyerCount': '{n}人',
  'dener.noBuyers': 'まだ私を通じて購入した人はいません。',
  'dener.buyersFail': '照会失敗（RPC制限の可能性があります）',

  // ── admin overlay ──
  'admin.title': '管理者 — <em>代理店管理</em>',
  'admin.subtitle': 'OWNER ADMIN',
  'admin.regPlaceholder': '代理店 .dex 名またはウォレットアドレス',
  'admin.regBtn': '+ 登録',
  'admin.regRequired': '登録する代理店 .dex 名またはウォレットアドレスを入力してください。',
  'admin.regInvalid': '.dex 名または 0x ウォレットアドレスを入力してください。',
  'admin.regAddressOk': '✓ ウォレットアドレス確認済み: {addr}',
  'admin.regResolved': '✓ {name} → BNB {addr}',
  'admin.detailEmpty': '← 代理店を選択してください',
  'admin.dBuyersK': '購入者数',
  'admin.dDiscK': '割引',
  'admin.dRwdK': '報酬',
  'admin.activeTitle': '代理店を有効化',
  'admin.activeDescDefault': '有効化するとこの代理店の割引・報酬が適用されます',
  'admin.lockTitle': '管理者ロック',
  'admin.lockDescDefault': 'ロック: 管理者のみ設定 / 解除: 代理店本人が設定',
  'admin.discRangeLabel': 'Dener割引率',
  'admin.rwdRangeLabel': '代理店報酬率',
  'admin.apply': 'この割引率・報酬率で設定（管理者ロック）',
  'admin.remove': '代理店を削除',
  'admin.noDistributors': '登録された代理店がありません。<br>上で .dex 名またはウォレットアドレスを登録してください。',
  'admin.listRates': '割引 {disc}% · 報酬 {rwd}% · <span class="{cls}">{status}</span>',
  'admin.activeDescOn': '有効状態 — 割引・報酬が適用されます',
  'admin.activeDescOff': '無効状態 — 割引・報酬は適用されません',
  'admin.lockDescOn': 'ロック中 — 管理者のみ割引率を設定可能',
  'admin.lockDescOff': '解除済み — 代理店本人が割引率を設定可能',
  'admin.regSign': '登録署名を確認してください…',
  'admin.registered': '✓ 登録されました',
  'admin.setSign': '設定署名を確認してください…',
  'admin.ratesSet': '✓ 設定されました（ロック）',
  'admin.toggleSign': '署名確認…',
  'admin.activated': '有効化',
  'admin.deactivated': '無効化',
  'admin.toggleResult': '✓ {state}されました',
  'admin.lockApplied': '✓ 管理者ロック（割引 {disc}% / 報酬 {rwd}%）',
  'admin.released': '✓ 代理店の自律に切り替え',
  'admin.removeSign': '削除署名を確認…',
  'admin.removed': '✓ 削除されました',

  // ── footer ──
  'footer.brand': 'Dig<em>Mol</em> — Dener叙任の鉱脈',
  'footer.line1': 'エルドラシア年代記 · PV叙任専用 隔離交換コントラクト',
  'footer.tag': 'DigMolPvGate · 独立デプロイ · メインエコシステムとは無関係',
  'footer.disc': '本ページのすべての情報は参考用であり、投資勧誘ではありません。© 2026 MolePin Community',

  // ── contract / refresh ──
  'contract.noAddr': '⚠ PV_GATE_ADDRESS 未設定 — .env に VITE_PV_GATE_ADDRESS を入れると実際の交換が動作します。',
  'contract.vein': '鉱脈 {link}',
  'refresh.rateNote': 'MOL {mol} · BNB {bnb} · 残りの鉱脈 {stock} MOL',
  'refresh.queryFail': '契約照会失敗: {msg}',

  // ── swap flow ──
  'swap.needAmount': '鉱脈に入れるBNB数量を入力してください。',
  'swap.noAddr': 'PV_GATE_ADDRESS が設定されていません（デプロイアドレスの入力が必要）。',
  'swap.failPrefix': '採掘失敗: {msg}',

  // ── tx states ──
  'tx.signing': 'ウォレットで署名を確認してください…',
  'tx.pendingMining': 'ツルハシが鉱脈を打つ… 確認待ち',
  'tx.confirming': 'ブロック確認待ち…',
  'tx.successDefault': '完了',
  'tx.successMined': '⛏ 採掘成功 — <b>{got}</b> 掘りました',
  'tx.viewTx': 'トランザクションを見る ↗',

  // ── error maps ──
  'err.userRejected': '署名が拒否されました。',
  'err.insufficientBnb': 'BNB残高が不足しています（交換額+ガス）。',
  'err.insufficientStock': '鉱脈のMOL在庫が不足しています。しばらくして再試行してください。',
  'err.gateClosed': '現在、鉱脈は閉じています。',
  'err.zeroAmount': '金額が0です。',
  'err.noGateAddr': 'コントラクトアドレスが設定されていません。',
  'err.tx.userCancelled': 'ウォレットで署名をキャンセルしました。',
  'err.tx.insufficientGas': 'ガス代（BNB）が不足しています。ウォレットにBNBを補充してください。',
  'err.tx.notOwner': '権限がありません（ownerウォレットで実行してください）。',
  'err.tx.notDist': '未登録の代理店です。',
  'err.tx.ownerLocked': '管理者がロックした代理店のため変更できません。',
  'err.tx.badDiscount': '割引率が範囲外です（0〜15%）。',
  'err.tx.badReward': '報酬率が範囲外です（0〜5%）。',
  'err.tx.network': 'ネットワークエラーです。しばらくして再試行してください。',
  'err.tx.unknown': '処理中に問題が発生しました。しばらくして再試行してください。',

  // ── ticker feed messages ──
  'feed.msg1': '新たな守護者が王国に加わりました',
  'feed.msg2': '一人のDenerが叙任を受けました',
  'feed.msg3': '滅びた王国に守護者が宿りました',
  'feed.msg4': 'エルドラシアの光がもう一つ灯りました',
  'feed.msg5': 'ツルハシを持つ守護者が現れました',

  // ── shared ──
  'common.loading': '読み込み中…',
  'common.txLink': 'tx ↗',
  'common.queryFail': '照会失敗',
};
